// extracted by mini-css-extract-plugin
export var cardContainer = "_o9-0";
export var cardHeader = "_o9-2";
export var collapsedState = "_o9-3";
export var dragHandle = "_o9-5";
export var dragHandleIcon = "_o9-6";
export var dragging = "_o9-1";
export var titleArea = "_o9-4";